import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ILoginModal, UpdateLoginModalAction} from "../../types/redux/login-modal";

const initialState: ILoginModal = {
  active: false,
  promptActive: false
};

export const LoginModalSlice = createSlice({
  name: UpdateLoginModalAction,
  initialState: initialState,
  reducers: {
    setLoginModalActive: (state: ILoginModal, action: PayloadAction<boolean>) => {
     state.active = action.payload;
    },

    setLoginPromptModalActive: (state: ILoginModal, action: PayloadAction<boolean>) => {
      state.promptActive = action.payload;
    }
  }
});

export const {
  setLoginModalActive,
  setLoginPromptModalActive
} = LoginModalSlice.actions;
export default LoginModalSlice.reducer;
